export const content = {
  title:'Combinar aseguradora',
  nodata:'Sin Registro',
  error:'Sin registro',
  button:'Confirmar',
  cancelButton:'Cancelar',
  image_button:'Cambiar',
  form:{
    new_insurance_carrier_id:{
      label:'Seleccione la aseguradora principal',
      placeholder:'Seleccione un elemento...',
    },
  },
}